<template>
  <div class="main-page-container">
    <AlertFoundActiveSession />
    <PageHeader
      :title="$t('sideNavbarMenu.reporting.list.timesheet')"
      :hasHeaderButton="true"
      class="page-top-header d-flex align-items-center vp-width-270"
    >
      <template #headerButton>
        <button class="regenerate-btn" @click="showTimesheetDetails">
          {{ $t("common.reGenerate") }}
        </button>
      </template>
    </PageHeader>
    <div>
      <div class="helpers-background">
        <div class="d-flex" style="height: 75px">
          <!-- begin:: Export -->
          <!-- <div class="export-dropdown"> -->
          <DxDropDownButton
            class="export-dropdown"
            :items="buttonData"
            :text="$t('common.grid.export')"
            @item-click="onItemClick"
          />
          <!-- </div> -->
          <!-- end::Export -->
        </div>
      </div>

      <section class="timesheet-pivot-grid timesheet-white-bg-sec">
        <DxScrollView :use-native="true">
          <DxPivotGrid
            :ref="pivotGridRef"
            :retrieve-fields="false"
            :show-borders="true"
            :data-source="dataSource"
            :show-column-grand-totals="false"
            @content-ready="onContentReady"
            :rtl-enabled="rtlEnabled"
          >
            <DxFieldPanel
              :show-data-fields="false"
              :show-row-fields="true"
              :show-column-fields="false"
              :show-filter-fields="false"
              :allow-field-dragging="false"
              :allow-sorting="false"
              :visible="true"
            >
            </DxFieldPanel>
            <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />

            <DxStateStoring
              :enabled="true"
              type="localStorage"
              storage-key="dx-timesheet-pivotgrid-storing"
            />
            <DxFieldChooser
              :enabled="true"
              :title="$t('common.grid.columnChooser')"
            />
            <!-- <DxExport :enabled="true" /> -->
          </DxPivotGrid>
          <p v-if="errorMessage" class="pivot-grid-error-message">
            {{ errorMessage }}
          </p>
        </DxScrollView>
      </section>
      <section class="grid-extension"></section>
    </div>
  </div>
</template>
<script>
import DxPivotGrid, {
  // DxExport,
  DxFieldChooser,
  DxFieldPanel,
  DxStateStoring,
  DxScrolling,
} from "devextreme-vue/pivot-grid";
import moment from "moment";
import PageHeader from "@/components/page-header";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportPivotGrid } from "devextreme/excel_exporter";
import DxDropDownButton from "devextreme-vue/drop-down-button";
// import DxButton from "devextreme-vue/button";
import { DxScrollView } from "devextreme-vue/scroll-view";
import AlertFoundActiveSession from "@/components/emergency/AlertFoundActiveSession";
import { rfidFormatterMixin } from "@/utils/mixins/rfidFormatterMixin";
import { mapGetters } from "vuex";

const pivotGridRef = "pivot-grid-ref";

export default {
  title: "Timesheet",
  components: {
    PageHeader,
    DxPivotGrid,
    DxFieldPanel,
    DxStateStoring,
    // DxExport,
    // DxButton,
    DxScrollView,
    DxFieldChooser,
    DxDropDownButton,
    DxScrolling,
    AlertFoundActiveSession,
  },
  mixins: [rfidFormatterMixin],
  data() {
    return {
      pivotGridRef,
      buttonData: ["Excel"],
      dataSource: [],
      errorMessage: "",
      rtlEnabled: false,
    };
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    pivotGrid() {
      return this.$refs[this.pivotGridRef].instance;
    },
  },
  methods: {
    // onCellPrepared($event){
    //   console.log($event)
    // },
    onContentReady() {
      this.$nextTick(() => {
            const pivotGrid = this.$refs.pivotGrid;
            if (pivotGrid) {
                pivotGrid.repaint(); // Force re-rendering
            }
        });
      // let ds = e.component.getDataSource();
      // let fullName = ds.field("fullName").area;
      // console.log(ds)
      // this.setColumnChooserPosition()
    },
    // setColumnChooserPosition() {
    //   var columnChooserView = this.dataGrid.getView("columnChooserView");
    //   if (!columnChooserView._popupContainer) {
    //     columnChooserView._initializePopupContainer();
    //     columnChooserView.render();
    //   }
    //   columnChooserView._popupContainer.option("position", {
    //     of: this.dataGrid.element(),
    //     my: "left top",
    //     at: "left top",
    //     offset: "0 50",
    //   });
    // },
    showTimesheetDetails() {
      this.$emit("showTimesheetDetails", true);
    },
    onItemClick(e) {
      if (e.itemData == "Excel") this.exportXLSX(e);
      else if (e.itemData == "CSV") this.exportCSV();
      // else if (e.itemData == "PDF") this.exportPDF();
    },
    exportXLSX(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Timesheet");
      exportPivotGrid({
        component: this.pivotGrid,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Timesheet.xlsx"
          );
        });
      });
      e.cancel = true;
    },
    exportCSV() {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Main sheet");
      exportPivotGrid({
        component: this.pivotGrid,
        worksheet: worksheet,
      }).then(function () {
        workbook.csv.writeBuffer().then(function (buffer) {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Timesheet.csv"
          );
        });
      });
    },
  },
  mounted() {
    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }
    this.$store.dispatch("timesheet/fetchTimesheet").then((res) => {
      this.dataSource = new PivotGridDataSource({
        // paginate: true,
        fields: [
          {
            caption: this.$t("common.fullName"),
            dataField: "fullName",
            area: "row",
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
          },
          {
            dataField: "siteTimeZon",
            // expanded: true,
            allowFiltering: false,
            allowSorting: false,
            isMeasure: false,
            visible: false,
          },
          {
            caption: this.$t("common.userType"),
            dataField: "userType",
            area: "row",
            allowFiltering: true,
            allowSorting: true,
            // expanded:true
            width: 150,
            isMeasure: false,
          },
          {
            caption: this.$t("common.site"),
            dataField: "site",
            area: "row",
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
          },
          {
            caption: this.$t("common.area"),
            dataField: "area",
            area: "row",
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
            customizeText: (e) => {
              if (!e.value) {
                return "-";
              }
              return e.value;
            },
          },
          {
            caption: "Company",
            dataField: "company",
            // area: "row",
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
            visible: false,
          },
          {
            caption: this.$t("common.email"),
            dataField: "emailAddress",
            // area: "row",
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
          },
          {
            caption: this.$t("common.phoneNumber"),
            dataField: "phoneNumber",
            // area: "row",
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
          },
          {
            caption: "Vehicle Registeration",
            dataField: "vehicleRegistration",
            // area: "row",
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
            visible: false,
          },
          {
            caption: "RFID",
            dataField: "rf_ids",
            // area: "row",
            // expanded: true,
            allowFiltering: false,
            allowSorting: false,
            isMeasure: false,
            customizeText: (e) => {
              if (!e.value?.length) {
                return "-";
              }
              return this.rfidFormatter(e.value);
            },
          },
          {
            dataField: "signed_in",
            area: "row",
            visible: false,
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
          },
          {
            dataField: "RFID",
            area: "row",
            visible: false,
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
          },
          {
            caption: this.$t("common.id"),
            dataField: "id",
            // area: "row",
            visible: false,
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
          },
          {
            dataField: "signed_out",
            area: "row",
            visible: false,
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
          },
          {
            caption: this.$t("common.id"),
            dataField: "user_user_id",
            // area: "row",
            // visible: false,
            // expanded: true,
            allowFiltering: true,
            allowSorting: true,
            isMeasure: false,
          },
          {
            area: "column",
            dataField: "date",
            dataType: "date",
            groupInterval: "year",
            expanded: true,
            isMeasure: false,
            selector: function (data) {
              const yearFormat = moment(data.date, "YYYY-MM-DD").format("YYYY");
              return `${yearFormat}`;
            },
          },
          {
            area: "column",
            dataField: "date",
            dataType: "date",
            groupInterval: "month",
            expanded: true,
            isMeasure: false,
            // selector: function(data) {
            //   const month = moment(data.date, "YYYY-MM-DD").format("MMMM");
            //   return month;
            // },
            sortBy: "value",
            // showDataFields:"false",
            // showColumnFields:"false",
          },
          {
            area: "column",
            dataField: "date",
            dataType: "date",
            groupInterval: "day",
            expanded: true,
            format: "ddd",
            isMeasure: false,
            // filterValues:[]
            // sortBy:"value",
            selector: function (data) {
              const day = moment(data.date, "YYYY-MM-DD").format(
                "ddd DD/MM/YYYY"
              );
              return day;
            },
            sortingMethod: function (a, b) {
              //Get day one & day two
              let first = a.text.split(" ")[1].split("/")[0];
              let second = b.text.split(" ")[1].split("/")[0];

              if (first > second) return 1;
              else if (first < second) return -1;
              else if (first === second) return 0;
            },
          },
          {
            caption: this.$t("common.duration"),
            dataField: "duration",
            visible: false,
          },
          {
            caption: this.$t("common.duration"),
            dataField: "duration_seconds",
            dataType: "number",
            area: "data",
            summaryType: "sum",
            isMeasure: true,
            customizeText: (e) => {
              if (!e.value) {
                return "-";
              }
              const sec = parseInt(e.value, 10);
              let hours = Math.floor(sec / 3600);
              let minutes = Math.floor((sec - hours * 3600) / 60);
              let seconds = sec - hours * 3600 - minutes * 60;
              hours = hours == 0 ? "" : hours + "h ";
              minutes = minutes == 0 ? "" : minutes + "m ";
              seconds = seconds == 0 ? "" : seconds + "s";
              return `${hours} ${minutes} ${seconds}`;
            },
          },
        ],
        store: res.data,
        onLoadError: (e) => {
          // Catch errors on data load
          console.log("Error loading data:", e);
          this.errorMessage = this.$t("common.notes.anErrorOccurredGrid");
        },
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.helpers-background {
  height: 75px;
  background: white !important;
  border-start-start-radius: 8px;
  border-start-end-radius: 8px;
}

#scrollview {
  height: auto;
  position: absolute;
  top: 0;
  bottom: 300px;
  padding: 20px;
}
button.regenerate-btn {
  width: 127px;
  height: 27px;
  border: none;
  background: #103f5e;

  border-radius: 13.5px;

  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 25px;
  color: #ffffff;
}

.export-dropdown {
  margin-inline-start: 24px;
}
</style>
<style lang="scss">
.grid-extension {
  height: 70px;
  background: #ffff;
  border-end-start-radius: 8px;
  border-end-end-radius: 8px;
}
section.timesheet-pivot-grid {
  .dx-area-field.dx-area-box.dx-pivotgrid-action {
    height: 46px;
    padding: 14px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #ffffff !important;
    .dx-area-field-content {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #939393;
    }
  }
  .dx-area-field.dx-area-box {
    height: 46px;
    padding: 14px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    .dx-area-field-content {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #939393;
    }
  }

  .dx-pivotgrid .dx-pivotgrid-area.dx-pivotgrid-area-data {
    font-size: 16px;
    font-weight: 400;
  }
  .dx-pivotgrid-fields-container
    .dx-area-field.dx-area-box
    .dx-header-filter.dx-header-filter-empty {
    color: #939393;
    font-weight: 900;
  }
  .dx-pivotgrid-fields-container .dx-sort {
    color: #939393;
    font-size: 14px !important;
    font-weight: 900 !important;
    width: 14px;
  }
  .dx-pivotgrid .dx-pivotgrid-horizontal-headers tr:first-child td {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 19px !important;

    color: #495057 !important;
  }
  td.dx-area-description-cell.dx-pivotgrid-background {
    background: #ffffff !important;
  }
}
.dx-pivotgrid-vertical-headers.dx-pivotgrid-area.dx-scrollable.dx-visibility-change-handler.dx-scrollable-vertical.dx-scrollable-simulated {
  font-size: 16px;
  font-weight: 400;
}
thead.dx-pivotgrid-horizontal-headers {
  font-size: 16px;
}
.timesheet-white-bg-sec {
  background-color: white;
  padding-inline-start: 0px;
  border-radius: 8px !important;
}

[aria-label="Column RFID"] {
  .dx-sort.dx-sort-up,
  .dx-sort.dx-sort-down {
    display: none !important;
  }
}

.pivot-grid-error-message {
  color: #ffff;
  padding: 14px 35px 14px 14px;
  background-color: #f88e86;
  white-space: normal;
  word-wrap: break-word;
}
</style>
